import { Component, OnInit, Inject } from '@angular/core';
import { RmsModule } from '@rms';
import { InventoryDataService, lastValueFrom, WebService, RmsMessageService } from '@services';
import { RmsPulldownRef } from '../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';

@Component({
  selector: 'app-group-filter',
  imports: [RmsModule],
  templateUrl: './group-filter.component.html',
  styleUrl: './group-filter.component.scss'
})
export class GroupFilterComponent implements OnInit {
  selectedCountryID: number | null = null;
  selectedRegionID: number | null = null;
  selectedOriginID: number | null = null;
  selectedGroupID: number | null = null;
  selectedGroupFilterID: number | null = null;
  selectedGroupFilter: any | null = null;
  selectedCustomGroup: any | null = null;
  CustomGroups: any[] = [];
  searchValue = '';
  Groups: any[] = [];
  Countries: any[] = [];
  Regions: any[] = [];
  filteredCountries: any[] = [];
  filteredGroups: any[] = [];
  SelectedGroupData: any[] = [];
  editGroups: boolean = false;
  saving = false;

  constructor(private inventoryDataService: InventoryDataService, private rmsPulldownRef: RmsPulldownRef, @Inject(RMS_PULLDOWN_DATA) private pulldownData: any, private web: WebService, private message: RmsMessageService) {
    this.CustomGroups = pulldownData.customGroups || [];
    this.rmsPulldownRef.dataChanges().subscribe((data: any) => {
      if (data?.customGroups) {
        this.CustomGroups = data.customGroups;

      }
    });
  }

  async ngOnInit() {
    await this.loadInventoryData();
  }


  async loadInventoryData() { 
    const data = await this.inventoryDataService.getData({ keys: ['Groups', 'Countries', 'Regions'] });
    this.Groups = data["Groups"];
    this.Countries = data["Countries"];
    this.Regions = data["Regions"];
  }
  onLoadGroup(GroupID: any) {
    const Group = this.CustomGroups.find(group => Number(group.CustomGroupFilterID) === Number(GroupID));
    if (!Group) return;
    this.selectedGroupFilter = {...Group};
    try { this.SelectedGroupData = JSON.parse(Group.CustomGroupFilter || '[]'); } catch { this.SelectedGroupData = []; }
    this.SelectedGroupData.forEach(row => {
      row.filteredCountries = this.Countries.filter(c => Number(c.RegionID ?? c.RegionId) === Number(row.RegionID));
      row.filteredGroups = this.Groups.filter(g => Number(g.CountryID) === Number(row.CountryID));
    });
  }
  onChangeRegion(index: number) {
    this.SelectedGroupData[index].CountryID = null;
    this.SelectedGroupData[index].GroupID = null;
    this.SelectedGroupData[index].filteredGroups = [];
    this.SelectedGroupData[index].filteredCountries = this.Countries.filter(country => Number(country.RegionID ?? country.RegionId) === Number(this.SelectedGroupData[index].RegionID));
  }
  onChangeCountry(index:number) {
    this.SelectedGroupData[index].GroupID = null;
    this.SelectedGroupData[index].filteredGroups = this.Groups.filter(group => Number(group.CountryID) === Number(this.SelectedGroupData[index].CountryID));
  }
  onCreateGroupFilter() {
    this.editGroups = true;
    this.selectedGroupFilter = {};
    this.SelectedGroupData = [{}];
  }
  onEditGroupFilter() {
    this.editGroups = true;
  }
  onAddGrouping() {
    this.SelectedGroupData.push({});
  }
  onDeleteGroup(index: number) {
    this.SelectedGroupData.splice(index, 1);
  }
  async onSaveGroupFilter() {
    if (this.saving || !this.selectedGroupFilter) return;
    if (!this.selectedGroupFilter.CustomGroupFilterName?.trim() || !this.SelectedGroupData.length || this.SelectedGroupData.some(g => !g.GroupID)) {
      this.message.warn('Enter a name and select a group for every row.'); return;
    }

    if (this.CustomGroups.length == 0) {
      this.selectedGroupFilter.PrimaryFilter = true;
    }

    const payload = {
      CustomGroupFilterID: this.selectedGroupFilter.CustomGroupFilterID ?? null,
      UserGUID: localStorage.getItem('GUID') || '',
      CustomGroupFilterName: this.selectedGroupFilter?.CustomGroupFilterName || '',
      CustomGroupFilter: JSON.stringify(this.SelectedGroupData.map(({RegionID, CountryID, GroupID}) => ({RegionID, CountryID, GroupID}))),
      PrimaryFilter: this.selectedGroupFilter.PrimaryFilter || false,
    }

    this.saving = true;
    try {
      await lastValueFrom(this.web.getWebCall('users', 'custom-group-filters/merge', { body: payload }));
      const groups = await lastValueFrom(this.web.getWebCall('users', 'custom-group-filters', {
        params: [{name:'UserID', value:localStorage.getItem('GUID') || ''}]
      }));
      this.CustomGroups = groups || [];
      const saved = this.CustomGroups.find(g => payload.CustomGroupFilterID
        ? Number(g.CustomGroupFilterID) === Number(payload.CustomGroupFilterID)
        : g.CustomGroupFilterName === payload.CustomGroupFilterName);
      this.editGroups = false;
      if (saved) { this.selectedGroupFilterID = saved.CustomGroupFilterID; this.onLoadGroup(saved.CustomGroupFilterID); }
      this.message.success(`"${payload.CustomGroupFilterName}" ${payload.CustomGroupFilterID ? 'updated' : 'created'}.`);
      this.rmsPulldownRef.sendData({action:'refresh'});
    } catch { this.message.error('Could not save or reload the custom group. Your entries are still available.'); }
    finally { this.saving = false; }
  }
}
